import { getParameterFromURL } from './getParameterFromUrl';

const FLOWS = {
  base: ['PDFUpselling', 'SuccessScreen'],
  pdfThenChat: ['PDFUpselling', 'ChatUpsale', 'SuccessScreen'],
  chatThenPdf: ['ChatUpsale', 'PDFUpselling', 'SuccessScreen'],
  pdfThenChatThenHardware: ['PDFUpselling', 'ChatUpsale', 'FakeHardwar', 'SuccessScreen'],
  pdfThenChatThenSupplements: ['PDFUpselling', 'ChatUpsale', 'SupplementsUpsale', 'SuccessScreen'],
  successOnly: ['SuccessScreen'],
} as const;


export const getScreenFlow = () => {
  const isSinglePlanCheckout = getParameterFromURL('singlePlanCheckout') !== null;
  if (isSinglePlanCheckout) {
    return FLOWS.successOnly;
  }

  const hasSupplementsParam = getParameterFromURL('supplements') !== null;
  if (hasSupplementsParam) {
    return FLOWS.pdfThenChatThenSupplements;
  }

  const hasHardwareParam = getParameterFromURL('hardware') !== null;
  if (hasHardwareParam) {
    return FLOWS.pdfThenChatThenHardware;
  }

  return FLOWS.pdfThenChat;
};
